import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="border-y border-background-200 bg-background-100/50">
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="常见问题"
            title="关于合集与盘点，你可能想知道"
            desc="如果这里没有解答你的疑问，欢迎通过页脚邮箱联系我们。"
          />
        </div>
        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"} />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 md:px-6">
                      <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}